import { IbundleData } from '../../interfaces';
import { createSelector } from '@ngrx/store';

const selectQuerydata = (state: IbundleData) => {
   return state;
  };

export const getQueryDataByIndex = (index, emitOnlyIfData = false) => createSelector(selectQuerydata, (queriesData) => {
  if (queriesData) {
    return queriesData[index];
  } else if (emitOnlyIfData) {
    return undefined;
  } else {
    return {};
  }
});
